<template>
  <kst-page-print-details page-footer
    v-slot="{ title }"
    @init="handleInit"
  >
    <div class="columns is-mobile">
      <div class="column is-half">
        <Company :data="companyData"/>
      </div>
      <div class="column is-half">
        <div class="is-size-3">{{ title }}</div>
      </div>
    </div>

    <div class="columns is-mobile">
      <div class="column">
        <Details :details="details"/>
      </div>
    </div>

    <Items class="block" :access="access" :items="details.Items"/>

    <template v-if="access.Glob_HPP">
      <Total class="block" :details="details"/>
    </template>
  </kst-page-print-details>
</template>

<script>
import Model from "../SttrModel.js";
import Services from "../../../services/Api/StockTrfServices.js";

import Company from "../../Company/RelatedPrintDetails/CpRPD.vue";
import Details from "./SttrPD_Details.vue";
import Items from "./SttrPD_Items.vue";
import Total from "./SttrPD_Total.vue";

export default {
  components: {
    Company,
    Details,
    Items,
    Total
  },
  data: () => ({
    access: {},
    details: {},
    companyData: {}
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadPrint) {
      this.resetData();

      const config = Services.getPrintDetailsData(id);
      loadPrint(config, this.handleInit_success);
    },
    handleInit_success(data) {
      this.details = data.Details;
      this.companyData = data.CompanyDetails;

      for (const item of this.details.Items) {
        Model.updateItemReadOnly(item);
      }
    },

    /*** custom ***/

    resetData() {
      this.access = this.$kst.Access.create(Model.Access);
      this.details = {};
      this.companyData = {};
    }
  }
}
</script>